<template>
  <b-form
    @submit.prevent="enviaEmailRecuperacaoSenha"
    class="user-form">

    <InputBasico
      type="email"
      label='E-mail*'
      name='email'
      :lowerCase='true'
      placeholder='Informe seu e-mail'
      v-model="form.to"
      v-validate="'required|email'"
      :errorsBag="errors"
    />

    <b-button
      type="submit"
      variant="primary"
      class="btnEnviarEmail">
      Enviar e-mail para login
    </b-button>

    <b-button
      variant="link"
      @click="mostrarCampoLogin">
      Voltar ao login
    </b-button>
  </b-form>
</template>

<script>
import bForm from 'bootstrap-vue/es/components/form/form'
import bButton from 'bootstrap-vue/es/components/button/button'
import InputBasico from '@/components/inputs/InputBasico.vue'

export default {
  name: 'RecuperarSenhaForm',
  components: {
    bForm,
    bButton,
    InputBasico,
  },
  data() {
    return {
      form: {
        to: '',
      },
    }
  },
  methods: {
    enviaEmailRecuperacaoSenha() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('enviarEmail', JSON.parse(JSON.stringify(this.form.to)))
        }
      })
    },
    mostrarCampoLogin() {
      this.$emit('recuperarConta')
    },
  },
}

</script>

<style lang="scss" scoped>
@import '@/scss/breakpoints.scss';
@import '@/scss/colors.scss';

.user-form {
  display: flex;
  flex-direction: column;

  padding: 2rem 1rem 1rem;
  border-radius: 0.3rem;
  box-shadow: 2px 4px 8px $cor-fundo-escura;
  background-color: $cor-fundo-clara;

  @media (min-width: $medium-size) {
    margin: 1em;
    width: 275px;
  }

  @media (min-width: $large-size) {
    width: 375px;
  }
}

.btnEnviarEmail {
  height: 3rem;
  margin: 1rem 0;
}

</style>
